import React, { useState, useEffect, useContext } from "react";
import { Container, Form, Table, Button, Modal } from "react-bootstrap";
import { apiGet, apiPut } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { isEmpty, startCase } from "lodash";

import "flatpickr/dist/themes/material_green.css";

import { toast } from "wc-toast";

import AuthContext from "../context/AuthContext";

import CopyToClipboard from "react-copy-to-clipboard";
import { FaFileExcel, FaRegCopy } from "react-icons/fa6";
import { CSVLink } from "react-csv";
import ReactPaginate from "react-paginate";
import { useParams } from "react-router-dom";
import moment from "moment";
import obj from "../utils/helpers";
const RegisteredUser = () => {
  let { user } = useContext(AuthContext);
  const { type } = useParams();
  var previousDate = moment()
    .subtract(type == "pending" ? 30 : 1, "days")
    .format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [matchData, setMatchData] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  const [search, setSearch] = useState({
    status: "active",
    keyword: "",
    page: 1,
    limit: 50,
    start_date: previousDate,
    end_date: currentDate,
  });

  const getMatchData = async (id) => {
    let api = apiPath?.allUser;
    if (type == "pending") {
      api = apiPath?.allUserPending;
    } else {
      api = apiPath?.allUser;
    }
    const { status, data: response_users } = await apiGet(api, search);
    if (status === 200) {
      if (response_users.success) {
        setMatchData(response_users.results);
        setPageCount(response_users?.results?.totalPages || []);
      }
    }
  };

  useEffect(() => {
    getMatchData(type);
  }, [type,search?.page]);

  const handlePageClick = (event) => {
    setSearch((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
    setViewPage(event.selected);
  };

  return (
    <div>
      <section className="main-inner-outer py-4">
        <Container fluid>
          <div className="db-sec">
            <h2 className="common-heading">{startCase(type)} Users</h2>
          </div>
          <Form className="mb-3 d-flex align-items-center">
            <Form.Control
              type="text"
              value={search?.keyword}
              className="w-25"
              style={{ marginRight: "15px" }}
              onChange={(e) => {
                setSearch((prev) => {
                  return { ...prev, keyword: e.target.value };
                });
              }}
              placeholder="search"
            />
            {type == "recent" && (
              <Form.Select
                value={search?.status}
                onChange={(e) => {
                  setSearch((prev) => {
                    return { ...prev, status: e.target.value };
                  });
                }}
                aria-label="Default select example"
                style={{ width: "150px" }}
              >
                <option value="active">Active</option>
                <option value="suspend">Suspend</option>
                <option value="locked">Locked</option>
              </Form.Select>
            )}
            <div
              className="bet-sec bet-period d-flex align-items-center"
              style={{ marginRight: "15px", marginLeft: "15px" }}
            >
              <Form.Label style={{ marginRight: "10px" }}>From</Form.Label>
              <Form.Control
                onChange={(e) =>
                  setSearch({
                    ...search,
                    start_date: e.target.value,
                  })
                }
                max={new Date().toISOString().split("T")[0]}
                value={search.start_date}
                type="date"
              />
            </div>
            <div
              className="bet-sec bet-period d-flex align-items-center"
              style={{ marginRight: "15px", marginLeft: "15px" }}
            >
              <Form.Label style={{ marginRight: "10px" }}>To</Form.Label>
              <Form.Control
                onChange={(e) =>
                  setSearch({
                    ...search,
                    end_date: e.target.value,
                  })
                }
                min={
                  search?.start_date
                    ? new Date(search?.start_date).toISOString().split("T")[0]
                    : new Date()
                }
                disabled={search.start_date ? false : true}
                max={new Date().toISOString().split("T")[0]}
                value={search.end_date}
                type="date"
              />
            </div>
            <Button
              type="button"
              className="theme_dark_btn"
              onClick={() => getMatchData()}
            >
              Search
            </Button>
            <CSVLink
              className="theme_dark_btn d-flex align-items-center"
              filename={`${type}.csv`}
              style={{
                marginLeft: "7px",
                background: "rgb(48, 48, 48)",
                textDecoration: "none",
              }}
              data={
                matchData?.data?.length > 0
                  ? type == "recent"
                    ? [
                        [
                          "Sr No.",
                          "User Name",
                          "Mobile Number",
                          "Status",
                          "Registered Date",
                        ],
                        ...matchData?.data?.map((res, index) => [
                          index + 1,
                          res?.username,
                          res?.phone_number1 || res?.phone,
                          startCase(res?.status),
                          obj.dateFormat(res?.createdAt),
                        ]),
                      ]
                    : [
                        ["Sr No.", "Mobile Number", "Date"],
                        ...matchData?.data?.map((res, index) => [
                          index + 1,
                          res?.phone_number1 || res?.phone,
                          obj.dateFormat(res?.createdAt),
                        ]),
                      ]
                  : [] || []
              }
              target="_blank"
            >
              <FaFileExcel size={15} style={{ marginRight: "5px" }} /> Export
            </CSVLink>
          </Form>
          <div className="inner-wrapper">
            <div className="common-container">
              <div className="account-table batting-table w-100">
                <div className="responsive">
                  <Table>
                    <thead>
                      <tr>
                        <th style={{ width: "5%" }} scope="col">
                          Sr No.
                        </th>
                        {type == "recent" && <th scope="col">User Name</th>}
                        <th scope="col">Mobile Number</th>
                        {type == "recent" && <th scope="col">Status</th>}{" "}
                        <th scope="col">
                          {type == "recent" && "Registered"} Date
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {matchData?.data &&
                        matchData?.data?.map((res, index) => {
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              {type == "recent" && <td>{res?.username}</td>}
                              <td>
                                <div className="d-flex justify-content-between align-items-center bg-white">
                                  <span className="bg-white text-dark">
                                    {res?.phone_number1 || res?.phone || "-"}
                                  </span>
                                  <CopyToClipboard
                                    onCopy={() => toast.success("Copied!")}
                                    text={res?.phone_number1 || res?.phone}
                                  >
                                    <FaRegCopy style={{ cursor: "pointer" }} />
                                  </CopyToClipboard>
                                </div>{" "}
                              </td>
                              {type == "recent" && (
                                <td>{startCase(res?.status)}</td>
                              )}
                              <td>{obj.dateFormat(res?.createdAt)}</td>
                            </tr>
                          );
                        })}
                      {isEmpty(matchData?.data) ? (
                        <tr>
                          <td colSpan={9}>No records found</td>
                        </tr>
                      ) : null}
                    </tbody>
                  </Table>
                  {matchData?.totalPages > 0 && (
                    <div className="bottom-pagination">
                      <ReactPaginate
                        breakLabel="..."
                        nextLabel=" >"
                        forcePage={viewpage}
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={10}
                        pageCount={pageCount}
                        previousLabel="< "
                        renderOnZeroPageCount={null}
                        activeClassName="p-1"
                        activeLinkClassName="pagintion-li"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default RegisteredUser;
